import { createClient } from "@connectrpc/connect";
import { grpcTransportProvider } from "../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../comun/services/grpc/mapConnectError";
import {
  MiProyectoDetalleResponse,
  MiProyectoItem,
  ProyectosClienteService,
} from "../../../generated/grpc/proyectos_pb";

/**
 * Proyectos del agricultor autenticado (`ProyectosClienteService`, gRPC-Web). Solo lectura.
 * El cliente lo resuelve el backend desde el token: acá no se manda ningún `clienteId`.
 *
 * SIN IndexedDB, a diferencia del resto de dominios: son pocos proyectos por agricultor y el
 * dato cambia cada vez que el técnico registra un gasto, así que una caché local daría cifras
 * viejas justo en lo que el agricultor viene a mirar (cuánto se ha ejecutado). Además, sumar
 * un store obliga a subir `DB_VERSION`, lo que **borra y recrea todos los stores** de la app
 * — un costo desproporcionado para esta pantalla.
 */
class ProyectoClienteGrpcService {
  async getMisProyectosAsync(): Promise<MiProyectoItem[]> {
    const client = createClient(ProyectosClienteService, grpcTransportProvider.get());
    try {
      const response = await client.getMisProyectos({});
      return response.items;
    } catch (error) {
      throw mapConnectError(error);
    }
  }

  async getDetalleAsync(proyectoId: string): Promise<MiProyectoDetalleResponse> {
    const client = createClient(ProyectosClienteService, grpcTransportProvider.get());
    try {
      return await client.getMiProyectoDetalle({ proyectoId });
    } catch (error) {
      throw mapConnectError(error);
    }
  }
}

/** Sin scope: el backend ya acota por el cliente del token, así que una instancia alcanza. */
export const proyectoClienteGrpcService = new ProyectoClienteGrpcService();
